import {
  goTo,
} from '../../actions/routing';
import config from '../../config';

export const FETCH_POLICIES_SUCCESS = 'myaxa/life/fetchPoliciesSuccess';
export const FETCH_POLICIES_CONDITIONS = 'myaxa/life/fetchPoliciesConditions';
export const FETCH_POLICIES_DETAILS = 'myaxa/life/fetchPoliciesDetails';

export const initialState = {
  lifeData: {
    profile: {
      lastName: {
        en: '',
        zh: '',
      },
    },
    policies: [],
    applications: [],
  },
  lifePolicies: [],
  myRequests: [],
  myAgents: [],
  conditions: {
    isInForce: false,
    hasAssignee: false,
    isDelegated: false,
    isCitibank: false,
    isSinglePremium: false,
  },
  details: {
    policyValue: {
      insuredAmount: 0,
      dividendBalance: 0,
      dividendInterest: 0,
      fpdBalance: 0,
      frdInterest: 0,
      loanBalance: 0,
      loanInterest: 0,
      terminationAmount: 0,
      splAmount: 0,
      amount: 0,
      bonusAmount: 0,
      rlsTransactionDate: '',
      faceValueReversionaryBonus: 0,
      faceValueTerminalBonus: 0,
      couponAmount: 0,
      couponInterest: 0,
      surrenderValue: 0,
    },
  },
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_POLICIES_SUCCESS: {
      return { ...state,
        lifeData: {
          profile: action.profile,
          policies: action.policies,
          applications: action.applications,
        },
        lifePolicies: action.policies,
        myRequests: action.myRequests,
        myAgents: action.myAgents,
      };
    }
    case FETCH_POLICIES_CONDITIONS: {
      return {
        ...state,
        conditions: {
          isInForce: action.isInForce,
          hasAssignee: action.hasAssignee,
          isDelegated: action.isDelegated,
          isCitibank: action.isCitibank,
          doesPolicyNeedToPay: action.doesPolicyNeedToPay,
          isSinglePremium: action.isSinglePremium,
        },
      };
    }
    case FETCH_POLICIES_DETAILS: {
      return {
        ...state,
        details: action.details,
      };
    }

    default:
      return state;
  }
}

export const dispatchToLink = (link, fullLink = false) => {
  return async (dispatch, getState) => {
    const currLang = getState().language.lang;
    if (fullLink) {
      window.location.href = link;
    } else {
      dispatch(goTo(`/${currLang}/${config.webview.identityFEPath}/${link}`));
    }
  };
};


